// @mui
import { Container, Typography } from '@mui/material';
import { m } from 'framer-motion';
import { observer } from 'mobx-react-lite';
import { useStores } from 'src/models';

// assets
import { ForbiddenIllustration } from '../assets/illustrations';
// components
import { MotionContainer, varBounce } from '../components/animate';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  roles?: string[];
  children: React.ReactNode;
};

function RoleBasedGuard({ hasContent, roles, children }: RoleBasedGuardProp) {
  // Logic here to get current user role
  const { authStore } = useStores();
  const { user } = authStore;

  if (!user) return null;

  const currentRole = 'admin';

  if (typeof roles !== 'undefined' && !roles.includes(currentRole)) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Permission Denied
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            You do not have permission to access this page
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
      </Container>
    ) : null;
  }

  return <>{children}</>;
}

export default observer(RoleBasedGuard);
